import { useState, useEffect } from "react";
import FeedbackBlock from "../blocks/FeedbackBlock";
import { Help, HelpItem, HelpLanguage } from "../interfaces/Help";
import parse from 'html-react-parser';
import { HashLink as Link } from "react-router-hash-link";
import { useNavigate } from "react-router-dom";
import { Video } from "../interfaces/Video";
import { replaceVideoShortcodes } from "../../utils/utils";
import { MainLayout } from "../layout/MainLayout";
import { useTranslation } from "react-i18next";

export default function HelpIndex() {
    const { t, i18n } = useTranslation();

    // Helper function to get translation for current language
    const getTranslation = (item: HelpItem) => {
        const currentLang = i18n.language as HelpLanguage;
        // Try to find translation for current language
        const translation = item.translations.find(t => t.lang === currentLang);
        // Fall back to default language or first available
        return translation || item.translations.find(t => t.lang === item.defaultLang) || item.translations[0];
    };

    const navigate = useNavigate();
    const [helps, setHelps] = useState<Help[]>();
    const [videos, setVideos] = useState<Video[]>([]);

    useEffect(() => {
        const requestOptionsGet = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        
        fetch(import.meta.env.VITE_API_URL + '/v1/help', requestOptionsGet)
            .then(response => {
                if (response.status !== 200) {
                    navigate('/');
                }
                return response.json();
            })
            .then(data => {
                setHelps(data);
                
            });
        
            const requestOptionsPost = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            };
        fetch(import.meta.env.VITE_API_URL + '/v1/video-tutorials', requestOptionsPost)
            .then(response => {
                if (response.status !== 200) {
                    navigate('/');
                }
                return response.json();
            })
            .then(data => {
                setVideos(data);
            });
    }, []);

    return (
        <MainLayout>
            { helps &&
                <div className="container-fluid">
                    <div className="row">
                        <h2>{ t("Help index") }</h2>
                    </div>
                    <div className="help-page">
                                <div className="help-index">
                                    <ol className="help-list-index">
                                        { helps && 
                                        helps.map((i: Help, index) => {
                                            return(
                                                <li className="help" 
                                                    key={ 'help-' + i._id + '-' + index}>
                                                    <Link to={"/help#"+i._id}>{ i.name && <p>{ i.name }</p>}</Link>
                                                    <ol>
                                                        {i.items.map((item: HelpItem, index) => {
                                                            const trans = getTranslation(item);
                                                            if(trans.title != "" && trans.title != i.name){
                                                                return (
                                                                    <li className="help-item"
                                                                    key={ 'help-item-' + i._id + '-' + index}>
                                                                    <Link to={"/help#"+i._id}>{ trans.title && <p>{ trans.title }</p>}</Link>
                                                                    </li>

                                                                )
                                                            }
                                                        })}
                                                    </ol>
                                                </li>
                                            )
                                        })}
                                    </ol>
                                </div>
                                <div className="help-text">
                                    <ol className="help-text-index">
                                    { helps && 
                                        helps.map((i: Help, index) => {
                                            return(
                                                <li className="help" 
                                                    key={ 'help-' + i._id + '-' + index}>
                                                    { i.name && <h4>{ i.name }</h4>}
                                                    <ol>
                                                        {i.items.map((item: HelpItem, index) => {
                                                            const trans = getTranslation(item);
                                                            const newTeaser: string = replaceVideoShortcodes(trans.teaser, videos);
                                                            const newBody: string = replaceVideoShortcodes(trans.body, videos);
                                                            return (
                                                                <li className="help-item" id={''+i._id}
                                                                key={ 'help-item-' + i._id + '-' + index}>
                                                                {trans.title && <h5 className="help-title">{ trans.title }</h5>}
                                                                {trans.teaser && <div className="help-teaser">{parse(newTeaser)}</div>}
                                                                {trans.body && <div className="help-body">{parse(newBody)}</div>}
                                                                {trans.examples && <div className="help-examples">{parse(trans.examples)}</div>}
                                                                </li>
                                                            )
                                                        })}
                                                    </ol>
                                                </li>
                                            )
                                        })}
                
                                    </ol>
                                </div>
                    </div>
                </div>
            }
            <FeedbackBlock/>
        </MainLayout>);
}
